import { render, staticRenderFns } from "./PreResources.vue?vue&type=template&id=f36a9dba&"
import script from "./PreResources.vue?vue&type=script&lang=ts&"
export * from "./PreResources.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports